/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
/**
 *
 * @export
 * @interface AppProjectsOilSchemasSchemasBlendOut
 */
export interface AppProjectsOilSchemasSchemasBlendOut {
  /**
   *
   * @type {string}
   * @memberof AppProjectsOilSchemasSchemasBlendOut
   */
  uuid: string;
  /**
   *
   * @type {string}
   * @memberof AppProjectsOilSchemasSchemasBlendOut
   */
  name: string;
}

/**
 * Check if a given object implements the AppProjectsOilSchemasSchemasBlendOut interface.
 */
export function instanceOfAppProjectsOilSchemasSchemasBlendOut(
  value: object
): value is AppProjectsOilSchemasSchemasBlendOut {
  if (!('uuid' in value) || value['uuid'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  return true;
}

export function AppProjectsOilSchemasSchemasBlendOutFromJSON(
  json: any
): AppProjectsOilSchemasSchemasBlendOut {
  return AppProjectsOilSchemasSchemasBlendOutFromJSONTyped(json, false);
}

export function AppProjectsOilSchemasSchemasBlendOutFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AppProjectsOilSchemasSchemasBlendOut {
  if (json == null) {
    return json;
  }
  return {
    uuid: json['uuid'],
    name: json['name']
  };
}

export function AppProjectsOilSchemasSchemasBlendOutToJSON(
  value?: AppProjectsOilSchemasSchemasBlendOut | null
): any {
  if (value == null) {
    return value;
  }
  return {
    uuid: value['uuid'],
    name: value['name']
  };
}
